import { UserActivity } from 'types/user_activity'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'

const resource = 'user_activities'

export const requests = {
  fetchPageViews: async (params: { start: string; end: string }) => {
    return await axiosForGigbaseBiz.get<DataResponse<UserActivity[]>>(
      `${resource}/page_views`,
      {
        params,
      },
    )
  },
}
